import _defineProperty from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.to-string.js";
import { queryReimburse, queryCate, submitReimburse as _submitReimburse, delReimburse as _delReimburse, withdrawReimburse as _withdrawReimburse } from '@/api/reimburse/reimburseApi.js';
export default {
  data: function data() {
    var columns = [{
      title: '报销编号',
      dataIndex: 'id',
      align: 'center',
      width: 100
    }, {
      title: '报销名称',
      dataIndex: 'fillName',
      align: 'center',
      ellipsis: true,
      width: 150
    }, {
      title: '报销金额',
      dataIndex: 'totalAmount',
      align: 'center',
      width: 90
    }, {
      title: '申请人',
      dataIndex: 'userName',
      align: 'center',
      width: 120,
      ellipsis: true,
      customRender: function customRender(userName, row) {
        return userName + ' (' + row.organName + '/' + row.postName + ')';
      }
    }, {
      title: '申请时间',
      dataIndex: 'createTime',
      ellipsis: true,
      align: 'center',
      width: 150
    }, {
      title: '报销状态',
      dataIndex: 'reimburseStatus',
      align: 'center',
      width: 80,
      scopedSlots: {
        customRender: 'reimburseStatus'
      }
    }, {
      title: '操作',
      dataIndex: 'action',
      align: 'center',
      width: 100,
      scopedSlots: {
        customRender: 'action'
      }
    }];
    return {
      cateList: [],
      loading: false,
      labelCol: {
        span: 5
      },
      wrapperCol: {
        span: 18
      },
      // pagination: this.$hdk.page(),
      pagination: this.$hdk.page(),
      expand: false,
      formState: {
        title: '',
        serialNumber: '',
        type: undefined,
        node: '',
        status: undefined,
        time: []
      },
      text: '',
      columns: columns,
      list: []
    };
  },
  methods: _defineProperty(_defineProperty(_defineProperty(_defineProperty({
    /**
     *切换分页时调用
     */
    change: function change(pagination) {
      this.getQueryReimburse({
        current: pagination.current,
        pageSize: pagination.pageSize,
        formState: this.formState
      });
    },
    /**
     * 撤回报销申请
     */
    withdrawReimburse: function withdrawReimburse(row) {
      var $confirm = this.$confirm,
        $message = this.$message,
        getQueryReimburse = this.getQueryReimburse;
      $confirm('确认撤回吗?', '提示', {
        type: 'info',
        confirmButtonText: '确认',
        cancelButtonText: '取消'
      }).then(function () {
        _withdrawReimburse(row.id).then(function (res) {
          $message.success('撤回成功');
          getQueryReimburse();
        });
      }).catch(function () {});
    },
    /**
     * 删除报销申请
     */
    delReimburse: function delReimburse(row) {
      var $confirm = this.$confirm,
        $message = this.$message,
        fetch = this.fetch;
      $confirm('确认删除吗?', '提示', {
        type: 'info',
        confirmButtonText: '确认',
        cancelButtonText: '取消'
      }).then(function () {
        _delReimburse(row.id).then(function (res) {
          $message.success('删除成功');
          fetch();
        });
      }).catch(function () {});
    },
    /**
     * 提交报销申请
     */
    submitReimburse: function submitReimburse(row) {
      var $confirm = this.$confirm,
        $message = this.$message,
        fetch = this.fetch;
      $confirm('确认提交吗?', '提示', {
        type: 'info',
        confirmButtonText: '确认',
        cancelButtonText: '取消'
      }).then(function () {
        _submitReimburse(row.id).then(function (res) {
          if (res.data.code == 200) {
            $message.success('提交成功');
            fetch();
          }
        });
      }).catch(function () {});
    },
    /**
     * 编辑报销
     */
    editReimburse: function editReimburse(row) {
      if (row.cateId === 1) {
        this.$router.push({
          path: '/reimburseRepairs/myReimburse/travelSingle',
          query: {
            fillId: row.id,
            path: 'reimbursement',
            type: 2
          }
        });
      } else if (row.cateId === 2) {
        this.$router.push({
          path: '/reimburseRepairs/myReimburse/expenseSingle',
          query: {
            fillId: row.id,
            path: 'reimbursement',
            type: 2
          }
        });
      }
    },
    /*
     * 查看
     */
    viewReimburse: function viewReimburse(row) {
      if (row.cateId === 1) {
        this.$router.push({
          path: '/reimburseRepairs/myReimburse/travelApproval',
          query: {
            fillId: row.id,
            path: 'reimbursement',
            type: 3
          }
        });
      } else if (row.cateId === 2) {
        this.$router.push({
          path: '/reimburseRepairs/myReimburse/expenseApproval',
          query: {
            fillId: row.id,
            path: 'reimbursement',
            type: 3
          }
        });
      }
    },
    /**
     * 条件筛选
     */
    searchClick: function searchClick() {
      this.pagination.current = 1;
      this.pagination.pageSize = 10;
      this.getQueryReimburse();
    },
    /**
     * 获取报肖登记列表
     */
    getQueryReimburse: function getQueryReimburse(options) {
      var _this = this;
      var pagination = this.pagination,
        formState = this.formState,
        pager = _.assign({}, pagination, options);
      this.loading = true;
      if (this.formState.time.length > 0) {
        this.formState.startTime = this.formState.time[0];
        this.formState.endTime = this.formState.time[1];
      } else {
        this.formState.startTime = null;
        this.formState.endTime = null;
      }
      if (!pager.formState) {
        pager.formState = formState;
      }
      // return;
      queryReimburse(pager.current, pager.pageSize, pager.formState).then(function (res) {
        _this.list = res.data.data;
        _.assign(pagination, {
          total: res.data.count,
          current: pager.current,
          pageSize: pager.pageSize
        });
        _.assign(formState, pager.formState);
      }).finally(function () {
        _this.loading = false;
      });
    },
    onFinish: function onFinish() {},
    search: function search() {},
    toggle: function toggle() {
      this.expand = !this.expand;
    }
  }, "change", function change() {}), "handleChange", function handleChange() {}), "cz", function cz() {
    this.$refs.searchFrom.resetFields();
  }), "pageChange", function pageChange(e) {
    this.pagination.current = e;
  }),
  mounted: function mounted() {
    var _this2 = this;
    this.getQueryReimburse();
    // 查询报销分类
    queryCate().then(function (res) {
      _this2.cateList = res.data.data;
    });
  }
};